export default __webpack_public_path__ + "static/media/dropbox.c7c1835c.svg";